import { getData } from "shared/api";
import { hasSellerAccount } from "shared/storeInfo";

export const startupsDashboardActionTypes = {
  SELECT_TAB: "SELECT_TAB",
  FETCH_PRODUCT_ANALYTICS: "FETCH_PRODUCT_ANALYTICS",
  FETCH_PRODUCT_LINES: "FETCH_PRODUCT_LINES",
  FETCH_PRODUCT_CUSTOMER_SEGMENTATION: "FETCH_PRODUCT_CUSTOMER_SEGMENTATION",
};

export function fetchProductLinesAction() {
  return {
    type: startupsDashboardActionTypes.FETCH_PRODUCT_LINES,
    payload: null,
  };
}

export function selectTabAction(tabKey) {
  return {
    type: startupsDashboardActionTypes.SELECT_TAB,
    payload: tabKey,
  };
}

export function fetchProductAnalyticsAction(productIds, productLine) {
  const productAnalyticsUrl = hasSellerAccount()
    ? "/startups/charts"
    : "/starter/fake_dashboard_charts";

  return {
    type: startupsDashboardActionTypes.FETCH_PRODUCT_ANALYTICS,
    payload: getData(productAnalyticsUrl, {
      product_ids: productIds,
      productLine,
    }),
  };
}

export function fetchProductCustomerSegmentationAction(
  productIds,
  productLine,
) {
  const productCustomerSegmentationUrl = hasSellerAccount()
    ? "/startups/customer_segmentation"
    : "/welcomeDashboardCustomerSegmentation.json";

  return {
    type: startupsDashboardActionTypes.FETCH_PRODUCT_CUSTOMER_SEGMENTATION,
    payload: getData(productCustomerSegmentationUrl, {
      product_ids: productIds,
      productLine,
    }),
  };
}
